import TastingModal from './TastingModal'
export default TastingModal
